import React from 'react';
import './PageLoader.css';

// Full-viewport loading state shown while the auth session (and its claims)
// resolve, so admins/members don't briefly see "Coming Soon" before their
// access is known. Intentionally minimal — no branding text, just a spinner.
const PageLoader = () => (
  <div className="page-loader" role="status" aria-label="Loading">
    <span className="page-loader-spinner" />
  </div>
);

export default PageLoader;
